<script setup lang="ts">
import {aboutData} from '~/components/homepage/about/constants';
</script>

<template>
    <section
        id="about"
        class="about"
    >
        <div class="about__inner">
            <div
                class="about__title"
                data-aos="fade-up"
            >
                <h3 class="about__caption">
                    {{ aboutData.title }}
                </h3>
            </div>
            <div class="about__content">
                <span
                    class="about__head"
                    data-aos="fade-up"
                >
                    {{ aboutData.head }}
                </span>

                <p
                    class="about__text"
                    data-aos="fade-up"
                >
                    {{ aboutData.description }}
                </p>

                <ul class="about-list">
                    <li
                        v-for="(item, index) in aboutData.list"
                        :key="`about-list-item-${index}`"
                        class="about-list__item"
                        data-aos="fade-up"
                    >
                        {{ item }}
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
@import "styles/about";
</style>
